import React, { useState } from "react";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import ApproveModal from "../ApproveModal";
import { Verified } from "lucide-react";

const EscalationActionButton = ({
  id,
  trustId,
  escalation,
  approved,
  approvalPremission,
  fetchEscalations,
  setLoading,
}) => {
  const [showApprove, setShowApprove] = useState(false);

  const toggleApproveModal = () => {
    setShowApprove(!showApprove);
  };

  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        {!approved ? (
          <>
            {approvalPremission ? (
              <>
                {/* <span>/</span> */}
                <CustomTooltip message={"Approve"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      size="1x"
                      onClick={() => {
                        toggleApproveModal();
                      }}
                    />
                  </span>
                </CustomTooltip>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <CustomTooltip message={"Approved"} >
            <Verified size={18} className="text-green-500" />
          </CustomTooltip>
        )}
      </span>

      {showApprove && (
        <ApproveModal
          showApprove={showApprove}
          id={id}
          type={"escalation"}
          toggleApproveModal={toggleApproveModal}
          setShowApprove={setShowApprove}
          trustId={trustId}
          fetchData={fetchEscalations}
          setLoading={setLoading}
        />
      )}
    </>
  );
};

export default EscalationActionButton;
